export { AnimatedText } from './AnimatedText';
